import { GetJuniferAccountsQuery } from "@/api/hasura/generated/graphql"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { AccountSyncResult } from "./accountSyncResult"
import { IAccountSyncResult, IAccountSyncUser } from "./accountSyncResult.types"
import { safeDayjs } from "@/helpers/dateHelper"
export type AccountSyncResultRaw = GetJuniferAccountsQuery["accounts"][0]

export const AccountSyncResultParser: IParser<
  IAccountSyncResult,
  AccountSyncResultRaw
> = {
  toDomain: (data: AccountSyncResultRaw) => {
    try {
      const toDate = data.toDttm?.startsWith("9999") ? undefined : data.toDttm
      const users: IAccountSyncUser[] =
        data.billing_account?.customer?.customer_user_rels
          .flatMap((rel) => rel?.user as IAccountSyncUser)
          .filter((u) => !!u) ?? []

      return new AccountSyncResult(
        data.number ?? "",
        data.customer?.number ?? "",
        data.id,
        data.billing_account?.id,
        data.customer?.name ?? "",
        data.last_transaction?.accountBalance ?? 0,
        safeDayjs(data.fromDttm),
        safeDayjs(toDate),
        safeDayjs(data.terminatedDttm),
        safeDayjs(data.closedDttm),
        safeDayjs(data.cancelledDttm),
        safeDayjs(data.createdDttm),
        !!data.billing_account,
        !!data.synchronized_account,
        !!data.synchronized_account?.locked,
        data.synchronized_account?.id,
        users,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
